import { FormProvider, useForm } from 'react-hook-form';

import { setComment } from '../../../api/stocksService';
import { closePopup } from '../../../store/slices/popupSlice';
import { updateComment } from '../../../store/slices/stocksSlice';
import { useAppDispatch, useAppSelector } from '../../../store/store';
import RedButton from '../../ui/buttons/redButton/RedButton';
import FormInput from '../../ui/formInput/FormInput';
import styles from './styles/styles.module.css';

function CommentPopup() {
  const dispatch = useAppDispatch();
  // const error = useAppSelector((state) => state.orders.error); //можно будет выводить ошибку в попап
  const popupProps = useAppSelector((state) => state.popup.popupProps);
  const { number } = popupProps;
  const { img } = popupProps;
  const handleClosePopup = () => {
    dispatch(closePopup());
  };

  const methods = useForm({
    defaultValues: {
      comment: popupProps.text,
    },
  });
  const { watch } = methods;
  const onSubmit = () => {
    const comment = watch('comment');
    setComment({
      grm: number,
      comment,
    }).then(() => {
      dispatch(
        updateComment({
          grm: number,
          comment,
        })
      );
      dispatch(closePopup());
    });
  };
  return (
    <div className={styles.stockCommentPopupWrapper}>
      <div>
        <img className={styles.commentImg} src={img} />
      </div>
      <div className={styles.topRow}>
        <h3 className={styles.stockCommentTitle}>
          Комментарий для грузоместа № {number}
        </h3>
        <button
          className={styles.closePopupButton}
          onClick={handleClosePopup}
          aria-label="Закрыть"
        />
      </div>
      <div className={styles.formWrapper}>
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <FormInput
              label="Ваш комментарий"
              inputName="comment"
              placeholderText="Что здесь хранится?"
              isTextarea
            />
            <button type="submit" style={{ display: 'none' }}>
              Отправить
            </button>
          </form>
        </FormProvider>
      </div>
      <RedButton text="Сохранить" width="100%" height={50} onClick={onSubmit} />
    </div>
  );
}

export default CommentPopup;
